import { CHANNEL_TYPES } from '../constants'

export default {
  SET_WORKFLOW_PROPERTY(state, obj) {
    state.mainWorkflow[obj.property] = obj.value
  },

  SET_TRIGGER_PROPERTY(state, obj) {
    state.mainWorkflow.workflowJson.triggers.values[0].data[obj.property] = obj.value
  },

  SET_STEP_PROPERTY(state, obj) {
    state.mainWorkflow.workflowJson.steps.values[0].data[obj.property] = obj.value
  },

  SET_CONTROL_PROPERTY(state, obj) {
    state.controls[obj.property] = obj.value
  },

  SETUP_CONTENT_SMS(state) {
    state.mainWorkflow.workflowJson.steps.values[0] = {
      id: '00000000-0000-0000-0000-000000000000',
      type: CHANNEL_TYPES.SEND_SMS,
      data: {
        templateId: null,
        senderId: null,
        text: null,
        senderName: null,
        scheduleDateTime: null,
        expirationDateTime: null,
        beginTime: null,
        endTime: null,
        isWorkingDays: null,
        timezone: null,
      },
    }
  },

  SETUP_CONTENT_EMAIL(state) {
    state.mainWorkflow.workflowJson.steps.values[0] = {
      id: '00000000-0000-0000-0000-000000000000',
      type: CHANNEL_TYPES.SEND_EMAIL,
      data: {
        templateId: null,
        senderId: null,
        subject: null,
        from: null,
        cc: null,
        bcc: null,
        contentType: 0,
        displayName: null,
        replyTo: null,
        scheduleDateTime: null,
        expirationDateTime: null,
        beginTime: null,
        endTime: null,
        isWorkingDays: null,
        timezone: null,
      },
    }
  },

  SET_VALIDATION_DETAIL(state, valid) {
    state.controls.validation.automationDetail = valid
  },

  SET_VALIDATION_AUDIENCE(state, valid) {
    state.controls.validation.audience = valid
  },

  SET_VALIDATION_ACTION(state, valid) {
    state.controls.validation.action = valid
  },

  SET_VALIDATION_CONTENT(state, valid) {
    state.controls.validation.content = valid
  },

  // Temporário para gerenciar blocos expandidos
  EXPAND_BLOCK(state, expanded) {
    state.automationDetail.expanded = expanded
  },

  SETUP_WORKFLOW(state, workflow) {
    state.mainWorkflow = workflow
    state.controls = {
      channelType: null,
      validation: {
        automationDetail: null,
        audience: null,
        action: null,
        content: null,
      },
    }
  },

  UPDATE_CURRENT_STEP(state, payload) {
    state.currentStep = payload
  },

  CLEAR_CURRENT_STEP(state) {
    state.currentStep = null
  },

  UPDATE_EMAIL_CONTENT(state, payload) {
    for (var item in payload.content) {
      state.mainWorkflow.steps.values[payload.indexStep].content[item] = payload.content[item]
    }
  },

  UPDATE_EMAIL_TEMPLATE_STEP(state, payload) {
    state.mainWorkflow.steps.values[payload.indexStep].content = {}
    state.mainWorkflow.steps.values[payload.indexStep].content.contentType = parseInt(payload.template.contentType)
    state.mainWorkflow.steps.values[payload.indexStep].content.templateId = payload.template.id
    state.mainWorkflow.steps.values[payload.indexStep].content.templateName = payload.template.name
    state.mainWorkflow.steps.values[payload.indexStep].content.thumbnailUri = payload.template.thumbnailUri
    state.mainWorkflow.steps.values[payload.indexStep].content.emailSimpleText = payload.template.emailSimpleText
    state.mainWorkflow.steps.values[payload.indexStep].content.isUnlayer = payload.template.isUnlayer
  },

  UPDATE_MAIN_WORKFLOW(state, payload) {
    state.mainWorkflow = payload
  },
}
